// extracted by mini-css-extract-plugin
export default {"colorPicker":"FkErp49OeUZEUVu4adZ8","colorPickerColor":"Dr4fOv6v1VAA53RNe9Q3","colorPickerLabel":"tK_ZB9YiN8AfWXHgqJTc"};